import {createAction, handleActions} from 'redux-actions';
import axios from 'axios/index';

import {loadPartList} from './PartReducer';
import {loadWageList} from './WageReducer';

export const setCarID = createAction('SET_CAR_ID');
export const setCarBrand = createAction('SET_CAR_BRAND');
export const setCarModel = createAction('SET_CAR_MODEL');
export const setCarDetail = createAction('SET_CAR_DETAIL');
export const setCarSize = createAction('SET_CAR_SIZE');
export const setCarType = createAction('SET_CAR_TYPE');
export const setPartID = createAction('SET_PART_ID');
export const setPartType = createAction('SET_PART_TYPE');
export const setPartBy = createAction('SET_PART_By');
export const updateCar = createAction('UPDATE_CAR');

export const CarReducer = (defaultState) => handleActions({
  [setCarID](state, action) {
    const {payload} = action;
    return {
      ...state,
      carID: payload.carID,
    };
  },
  [setCarBrand](state, action) {
    const {payload} = action;
    return {
      ...state,
      carBrand: payload.carBrand,
    };
  },
  [setCarModel](state, action) {
    const {payload} = action;
    return {
      ...state,
      carModel: payload.carModel,
    };
  },
  [setCarDetail](state, action) {
    const {payload} = action;
    return {
      ...state,
      carDetail: payload.carDetail,
    };
  },
  [setPartID](state, action) {
    const {payload} = action;
    return {
      ...state,
      partID: payload.partID,
    };
  },
  [setCarSize](state, action) {
    const {payload} = action;
    return {
      ...state,
      carSize: payload.carSize,
    };
  },
  [setCarType](state, action) {
    const {payload} = action;
    return {
      ...state,
      carType: payload.carType,
    };
  },
  [setPartType](state, action) {
    const {payload} = action;
    return {
      ...state,
      partType: payload.partType,
    };
  },
  [setPartBy](state, action) {
    const {payload} = action;
    return {
      ...state,
      partBy: payload.partBy,
    };
  },
  [updateCar](state, action) {
    const {payload} = action;

    if (payload.view) {
      let workdoc_storage = JSON.parse(localStorage.getItem('kkc_workdoc') ||
                            '{}') || {};
      workdoc_storage.damabeTableView = payload.view;

      localStorage.setItem('kkc_workdoc', JSON.stringify(workdoc_storage));
    }

    return {
      ...state,
      ...payload,
    };
  },
}, defaultState);

export default CarReducer;



// WEBPACK FOOTER //
// ./src/stores/CarDamage/CarReducer.js